import { CountryCode, SubscriptionPlan, ProductCodeKey } from '@dayetopia/library';
import checkResStatus from '@utils/checkResStatus';
import getOmsUrl from '@utils/getOmsUrl';
import { showInCountryCondition } from './country';

export const handleFetchProductPriceAndSubscriptionPlans = async (basePrice: number, productCode: string, country: CountryCode) => {
  if (!productCode) return [];
  const plans = await getSubscriptionPlans(productCode as ProductCodeKey);
  const updatedPlans = plans.map((p: SubscriptionPlan) => {
    const discountPercent = p.discountPercent[country] ?? p.discountPercent.default;
    const itemPrice = basePrice - (basePrice * discountPercent) / 100;
    // No rounding for TamponBox or Pads - only round for other products
    const shouldRound = productCode !== ProductCodeKey.TamponBox && productCode !== ProductCodeKey.Pads;
    const discountedPrice = shouldRound ? Math.round(itemPrice * 20) / 20 : itemPrice;
    const installmentPrice = calculateInstallmentPrice(p, discountedPrice);

    return {
      ...p,
      basePrice,
      discountedPrice,
      billing: { ...p.billing, installmentPrice }
    };
  });

  const filteredPlans = updatedPlans.filter((sp) => showInCountryCondition(sp.showInCountries, country));
  filteredPlans.sort((a, b) => a.discountPercent.default - b.discountPercent.default);

  return filteredPlans;
};

const calculateInstallmentPrice = (subscription: SubscriptionPlan, discountedPrice: number) => {
  if (subscription.productCode === ProductCodeKey.ScreeningKit) {
    return discountedPrice * subscription.delivery.installments;
  }
  if (subscription.productCode === ProductCodeKey.Pads) {
    return (discountedPrice * subscription.subscriptionInterval.length) / subscription.billing.installments;
  }
  return (discountedPrice * subscription.subscriptionInterval.length) / subscription.billing.installments;
};

export const getSubscriptionPlans = async (productCode: ProductCodeKey): Promise<SubscriptionPlan[]> => {
  const subscriptionProductCodes = [
    ProductCodeKey.Pads,
    ProductCodeKey.ScreeningKit,
    ProductCodeKey.TamponBox,
    ProductCodeKey.Proviotics,
    ProductCodeKey.PPCTamponBox
  ];
  if (!subscriptionProductCodes.includes(productCode)) return [];
  const subscriptionPlans = await getPlans();
  return subscriptionPlans;

  async function getPlans() {
    const oms = getOmsUrl();
    const url = `${oms}/ecommerce/subscriptions/${productCode}`;
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    };
    return fetch(url, options)
      .then((res) => checkResStatus(res))
      .then((json) => json)
      .catch((err) => {
        throw err;
      });
  }
};
